"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconSize = exports.default = exports.THEME = exports.SELECT_SEGMENT = exports.COMPONENT_NAME = exports.COLOR_THEME = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gerenciatdUnifiedicons = _interopRequireDefault(require("@bit/gerenciatd.unifiedicons.svg-icon-loader"));
var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));
var _gerenciatdUtils = require("@bit/gerenciatd.utils.validators");
var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.metrics");
require("./Input.scss");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
const THEME = {
  LINE: 'line',
  ROUNDED: 'rounded',
  BOX: 'box',
  FORM: 'form',
  FORMBOX: 'formBox'
};
exports.THEME = THEME;
const SELECT_SEGMENT = {
  GP: 'gp',
  EMP: 'emp',
  DEFAULT: 'gp'
};
exports.SELECT_SEGMENT = SELECT_SEGMENT;
const COLOR_THEME = {
  WHITE: 'white'
};
exports.COLOR_THEME = COLOR_THEME;
const getIconSize = inputType => {
  switch (inputType) {
    case THEME.LINE:
      return 24;
    case THEME.ROUNDED:
      return 20;
    default:
      return 24;
  }
};
exports.getIconSize = getIconSize;
const COMPONENT_NAME = 'Input';
exports.COMPONENT_NAME = COMPONENT_NAME;
class Input extends _react.Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    _defineProperty(this, "validateInput", function (value) {
      let saveValidation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      const {
        validators
      } = _this.state;
      const {
        error,
        pattern
      } = _this.props;
      let validationObj = {
        validated: true,
        errorMsg: ''
      };
      validators.forEach(validator => {
        if (validationObj.validated) {
          validationObj = validator(value, _this.props, pattern);
        }
      });
      if (!validationObj.errorMsg && error) {
        validationObj.errorMsg = error;
      }
      if (saveValidation) {
        _this.setState({
          error: validationObj.errorMsg
        });
      }
      return validationObj;
    });
    _defineProperty(this, "handleOnFocus", () => {
      const {
        info,
        isReadOnly,
        taggingInfo = {},
        name
      } = this.props;
      const finalTaggingInfo = _objectSpread(_objectSpread({}, taggingInfo), {}, {
        componentVariation: taggingInfo.componentVariation || 'all',
        componentProduct: taggingInfo.componentProduct || '',
        componentName: taggingInfo.componentName || COMPONENT_NAME,
        eventType: 'focus',
        componentContent: `input-${name}`
      });
      (0, _gerenciatdUtils2.sendCMSEvent)(finalTaggingInfo);
      if (info && !isReadOnly) {
        this.setState({
          showInfo: true
        });
      }
      this.setState({
        toggleLabel: true,
        animatedBar: true
      });
    });
    _defineProperty(this, "handleOnBlur", event => {
      const {
        onBlur,
        isAutocomplete
      } = this.props;
      const {
        value
      } = this.state;
      const eventObj = event;
      let currentValue = '';
      if (isAutocomplete && eventObj.relatedTarget) {
        currentValue = eventObj.relatedTarget.innerText || value;
      } else {
        currentValue = eventObj.currentTarget.value;
      }
      const validationObj = this.validateInput(currentValue);
      eventObj.validationObj = validationObj;
      let toggleLabel = false;
      if (currentValue) {
        toggleLabel = true;
      }
      this.setState({
        toggleLabel,
        animatedBar: false,
        value: currentValue
      });
      if (onBlur) {
        onBlur(eventObj);
      }
    });
    _defineProperty(this, "setCssColorTheme", colorTheme => {
      return `e-skeletonInput--theme-${colorTheme}`;
    });
    _defineProperty(this, "handleChange", event => {
      const eventObj = event;
      const {
        onChange,
        saveOnChangeValidation
      } = this.props;
      const {
        value
      } = eventObj.currentTarget;
      const validationObj = this.validateInput(value, saveOnChangeValidation);
      eventObj.validationObj = validationObj;
      let toggleLabel = false;
      if (value) {
        toggleLabel = true;
      }
      this.setState({
        toggleLabel,
        animatedBar: false,
        value
      });
      if (onChange) {
        onChange(eventObj);
      }
    });
    _defineProperty(this, "cleanInput", () => {
      const {
        cleanAction,
        error
      } = this.props;
      if (cleanAction) {
        cleanAction();
      }
      this.setState({
        value: '',
        toggleLabel: false,
        error
      });
    });
    _defineProperty(this, "handleOnPaste", e => {
      e.preventDefault();
    });
    _defineProperty(this, "handleOnClickHideIcon", () => {
      const {
        showPassword
      } = this.state;
      this.setState({
        showPassword: !showPassword
      });
    });
    _defineProperty(this, "handleKeyPress", e => {
      if (e.key === 'Enter') {
        this.handleOnBlur(e);
      }
    });
    const _validators = [];
    const {
      required,
      minLength,
      maxLength,
      pattern: _pattern,
      name: _name,
      validators: validatorsArray,
      defaultValue,
      error: _error
    } = this.props;
    let _toggleLabel = false;
    if (defaultValue) {
      _toggleLabel = true;
    }
    if (required) {
      _validators.push((0, _gerenciatdUtils.getValidator)(_gerenciatdUtils.validatorList.REQUIRED));
    }
    if (_pattern) {
      _validators.push((0, _gerenciatdUtils.getValidator)(_gerenciatdUtils.validatorList.PATTERN));
    }
    if (minLength > 0 || maxLength < 999) {
      _validators.push((0, _gerenciatdUtils.getValidator)(_gerenciatdUtils.validatorList.LENGTH));
    }
    if (Array.isArray(validatorsArray)) {
      validatorsArray.forEach(validatorName => {
        const validator = (0, _gerenciatdUtils.getValidator)(validatorName);
        if (validator) {
          _validators.push(validator);
        } else {
          console.warn(`Invalid validator: ${validatorName} in ${_name}`);
        }
      });
    }
    this.state = {
      toggleLabel: _toggleLabel,
      error: _error,
      value: defaultValue,
      validators: _validators,
      showPassword: false,
      showInfo: false
    };
  }
  componentDidMount() {
    const {
      formSkeletonProps
    } = this.props;
    if (formSkeletonProps) {
      const {
        activateFormElement
      } = formSkeletonProps;
      if (activateFormElement) {
        activateFormElement();
      }
    }
  }
  shouldComponentUpdate(nextProps) {
    const {
      formSkeletonProps
    } = this.props;
    if (formSkeletonProps) {
      const {
        submitTries
      } = formSkeletonProps;
      if (submitTries < nextProps.formSkeletonProps.submitTries) {
        const {
          value
        } = this.state;
        const validationObj = this.validateInput(value);
        if (nextProps.error) {
          validationObj.errorMsg = nextProps.error;
          validationObj.validated = false;
          this.setState({
            error: nextProps.error
          });
        }
        const {
          validateFormElement
        } = formSkeletonProps;
        if (validateFormElement) {
          validateFormElement(validationObj);
        }
        return false;
      }
    }
    const {
      error
    } = this.props;
    if (error !== nextProps.error) {
      this.setState({
        error: nextProps.error
      });
      return false;
    }
    const {
      defaultValue
    } = this.props;
    if (defaultValue !== nextProps.defaultValue && nextProps.defaultValue !== this.state.value) {
      this.setState({
        value: nextProps.defaultValue,
        toggleLabel: !!nextProps.defaultValue
      });
      return false;
    }
    return true;
  }
  componentWillUnmount() {
    const {
      formSkeletonProps
    } = this.props;
    if (formSkeletonProps) {
      const {
        deactivateFormElement
      } = formSkeletonProps;
      if (deactivateFormElement) {
        deactivateFormElement();
      }
    }
  }
  render() {
    const {
      id,
      name,
      cleanButton,
      svgIconProps,
      theme,
      colorTheme,
      placeHolder,
      actionInput,
      autoComplete,
      taggingInfo,
      allowPaste,
      isReadOnly,
      inputDescription,
      toggleLabel: toggleLabelProp,
      pattern,
      className,
      showHideIcon,
      info,
      segment
    } = this.props;
    let {
      typeField
    } = this.props;
    const {
      showPassword,
      showInfo
    } = this.state;
    if (typeField === 'password' && showPassword) {
      typeField = 'text';
    }
    const {
      value,
      toggleLabel,
      animatedBar,
      error
    } = this.state;
    const inputThemeCss = this.setCssColorTheme(colorTheme);
    const inputTypeCss = `e-skeletonInput e-skeletonInput--${theme}--${segment}`;
    const handleActionInput = () => {
      if (actionInput) {
        actionInput();
      }
    };
    let validationColor = 'blue';
    if (error) {
      validationColor = 'red';
    }
    if (isReadOnly) {
      validationColor = 'grey';
    }
    let labelCss = `e-skeletonInput__label e-skeletonInput__label--${validationColor}`;
    let barCss = `e-skeletonInput__bar--${validationColor}`;
    if (toggleLabel && toggleLabelProp) {
      labelCss = `${labelCss} toggleLabel`;
    }
    if (animatedBar) {
      barCss = `${barCss} animatedBar`;
    }
    const finalTaggingInfo = _objectSpread(_objectSpread({}, taggingInfo), {}, {
      componentVariation: taggingInfo.componentVariation || 'all',
      componentProduct: taggingInfo.componentProduct || '',
      componentName: taggingInfo.componentName || COMPONENT_NAME,
      componentContent: `input-${name}`
    });
    if (theme === THEME.FORMBOX) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: `${inputTypeCss} ${inputThemeCss} ${className}`,
        children: [svgIconProps && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
          className: "e-skeletonInput__icon",
          onClick: handleActionInput,
          taggingInfo: _objectSpread(_objectSpread({}, finalTaggingInfo), {}, {
            componentContent: `${finalTaggingInfo.componentContent}-icon`
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, _objectSpread(_objectSpread({}, svgIconProps), {}, {
            size: getIconSize(theme)
          }))
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "e-skeletonInput__fieldWrapper",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
            htmlFor: id,
            className: labelCss,
            children: placeHolder
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
            id: id,
            type: typeField,
            name: name,
            className: 'e-skeletonInput__field',
            autoComplete: autoComplete,
            pattern: pattern,
            placeholder: placeHolder,
            onFocus: this.handleOnFocus,
            onChange: this.handleChange,
            onBlur: this.handleOnBlur,
            onPaste: allowPaste ? null : this.handleOnPaste,
            onKeyPress: this.handleKeyPress,
            value: value,
            readOnly: isReadOnly
          }), cleanButton && value && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
            forceExternal: true,
            className: "e-skeletonInput__actionIcon",
            onClick: this.cleanInput,
            taggingInfo: _objectSpread(_objectSpread({}, finalTaggingInfo), {}, {
              componentContent: `${finalTaggingInfo.componentContent}-clean-icon`
            }),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, {
              id: "Cerrar",
              kind: "L",
              size: 16
            })
          }), showHideIcon && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_gerenciatdUnifiedcomponents.default, {
            forceExternal: true,
            className: "e-skeletonInput__actionIcon showPasswordIcon",
            onClick: this.handleOnClickHideIcon,
            taggingInfo: _objectSpread(_objectSpread({}, finalTaggingInfo), {}, {
              componentContent: `${finalTaggingInfo.componentContent}-eye-icon`
            }),
            children: [!showPassword && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, {
              id: "Ver",
              kind: "L",
              size: 16
            }), showPassword && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, {
              id: "NoVer",
              kind: "L",
              size: 16
            })]
          })]
        }), error && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: `e-skeletonInput__error--${segment}`,
          children: error
        }), showInfo && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: `e-skeletonInput__info--${segment}`,
          children: info
        }), !error && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: `e-skeletonInput__description--${segment}`,
          children: inputDescription || (theme === THEME.FORMBOX ? '\u00A0' : '')
        })]
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: `${inputTypeCss} ${inputThemeCss} ${className}`,
      children: [svgIconProps && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        className: "e-skeletonInput__icon",
        onClick: handleActionInput,
        taggingInfo: _objectSpread(_objectSpread({}, finalTaggingInfo), {}, {
          componentContent: `${finalTaggingInfo.componentContent}-icon`
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, _objectSpread(_objectSpread({}, svgIconProps), {}, {
          size: getIconSize(theme)
        }))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
        htmlFor: id,
        className: labelCss,
        children: placeHolder
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "e-skeletonInput__fieldWrapper",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          id: id,
          type: typeField,
          name: name,
          className: `e-skeletonInput__field e-skeletonInput__field--${validationColor}`,
          autoComplete: autoComplete,
          pattern: pattern,
          placeholder: placeHolder,
          onFocus: this.handleOnFocus,
          onChange: this.handleChange,
          onBlur: this.handleOnBlur,
          onPaste: allowPaste ? null : this.handleOnPaste,
          onKeyPress: this.handleKeyPress,
          value: value,
          readOnly: isReadOnly
        }), cleanButton && value && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
          forceExternal: true,
          className: "e-skeletonInput__actionIcon",
          onClick: this.cleanInput,
          taggingInfo: _objectSpread(_objectSpread({}, finalTaggingInfo), {}, {
            componentContent: `${finalTaggingInfo.componentContent}-clean-icon`
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, {
            id: "Cerrar",
            kind: "L",
            size: 16
          })
        }), showHideIcon && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_gerenciatdUnifiedcomponents.default, {
          forceExternal: true,
          className: "e-skeletonInput__actionIcon showPasswordIcon",
          onClick: this.handleOnClickHideIcon,
          taggingInfo: _objectSpread(_objectSpread({}, finalTaggingInfo), {}, {
            componentContent: `${finalTaggingInfo.componentContent}-eye-icon`
          }),
          children: [!showPassword && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, {
            id: "Ver",
            kind: "L",
            size: 16
          }), showPassword && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, {
            id: "NoVer",
            kind: "L",
            size: 16
          })]
        })]
      }), !isReadOnly && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: `e-skeletonInput__bar ${barCss}`
      }), error && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `e-skeletonInput__error--${segment}`,
        children: error
      }), showInfo && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `e-skeletonInput__info--${segment}`,
        children: info
      }), !error && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `e-skeletonInput__description--${segment}`,
        children: inputDescription || (theme === THEME.FORM ? '\u00A0' : '')
      })]
    });
  }
}
Input.propTypes = {
  /* Appearance */
  id: _propTypes.default.string.isRequired,
  isAutocomplete: _propTypes.default.bool,
  svgIconProps: _propTypes.default.object,
  theme: _propTypes.default.oneOf([THEME.LINE, THEME.ROUNDED, THEME.BOX, THEME.FORM, THEME.FORMBOX]),
  colorTheme: _propTypes.default.oneOf([COLOR_THEME.WHITE]),
  onChange: _propTypes.default.func,
  typeField: _propTypes.default.string,
  name: _propTypes.default.string,
  autoComplete: _propTypes.default.string,
  placeHolder: _propTypes.default.string,
  cleanButton: _propTypes.default.bool,
  cleanAction: _propTypes.default.func,
  actionInput: _propTypes.default.func,
  allowPaste: _propTypes.default.bool,
  isReadOnly: _propTypes.default.bool,
  defaultValue: _propTypes.default.string,
  toggleLabel: _propTypes.default.bool,
  className: _propTypes.default.string,
  required: _propTypes.default.bool,
  minLength: _propTypes.default.number,
  maxLength: _propTypes.default.number,
  validators: _propTypes.default.arrayOf(String),
  error: _propTypes.default.string,
  taggingInfo: _propTypes.default.object,
  inputDescription: _propTypes.default.string,
  pattern: _propTypes.default.string,
  showHideIcon: _propTypes.default.bool,
  info: _propTypes.default.string,
  saveOnChangeValidation: _propTypes.default.bool,
  segment: _propTypes.default.oneOf(Object.values(SELECT_SEGMENT)),
  formSkeletonProps: _propTypes.default.shape({
    submitTries: _propTypes.default.number.isRequired,
    validationTries: _propTypes.default.number.isRequired,
    activateFormElement: _propTypes.default.func.isRequired,
    deactivateFormElement: _propTypes.default.func.isRequired,
    validateFormElement: _propTypes.default.func.isRequired,
    validateForm: _propTypes.default.bool.isRequired
  })
};
Input.defaultProps = {
  isAutocomplete: false,
  svgIconProps: null,
  theme: THEME.LINE,
  colorTheme: COLOR_THEME.WHITE,
  onChange: null,
  typeField: 'text',
  name: '',
  autoComplete: 'on',
  placeHolder: '',
  cleanButton: false,
  cleanAction: null,
  actionInput: null,
  allowPaste: true,
  isReadOnly: false,
  defaultValue: '',
  toggleLabel: true,
  className: '',
  required: false,
  minLength: null,
  maxLength: null,
  validators: [],
  error: '',
  taggingInfo: {},
  inputDescription: '',
  pattern: null,
  showHideIcon: false,
  info: '',
  saveOnChangeValidation: false,
  formSkeletonProps: null,
  segment: SELECT_SEGMENT.DEFAULT
};
var _default = Input;
exports.default = _default;

//# sourceMappingURL=index.js.map